import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from 'react-redux';
import {useDispatch} from 'react-redux';
import {editSatisfaction} from 'web/redux/actions/SatisfactionAction';
import enumList from 'web/utils/enumList';
import {showMessage} from 'web/utils/modalHelper';
/**
 *
 */
export default function SatisfactionModal({
  isOpen,

  onOpenChange = () => {},
  reloadData = () => {},
}) {
  const dispatch = useDispatch();
  const satisfactionModalRef = useRef();
  const [satisfactionFormValue, setSatisfactionFormValue] = useState({
    caseId: '',
    satisfactionScore: 0,
    comment: '',
  });

  useEffect(() => {
    if (satisfactionModalRef.current) {
      satisfactionModalRef.current = new bootstrap.Modal(
        satisfactionModalRef.current,
      );
    }
  }, []);

  const data = useSelector((state) => state.satisfaction.selection);
  useEffect(() => {
    if (isOpen && data) {
      satisfactionModalRef.current.show();
      setSatisfactionFormValue({
        caseId: data.caseId,
        satisfactionScore: data.satisfactionScore,
        comment: data.comment,
      });
    }
  }, [isOpen, data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await dispatch(
        editSatisfaction(satisfactionFormValue),
      ).unwrap();
      if (res.code.isSuccessCode()) {
        onClose();
        reloadData();
        showMessage(enumList.messageModalMode.info, '編輯成功');
      } else {
        const error = new Error();
        error.responseMessage = res.payload.message;
        throw error;
      }
    } catch (error) {
      console.error(error);
      showMessage(
        enumList.messageModalMode.error,
        error.responseMessage ?? '發生錯誤',
      );
    }
  };

  const handleScoreTouch = (index) => {
    setSatisfactionFormValue({
      ...satisfactionFormValue,
      satisfactionScore: index,
    });
  };

  const onClose = () => {
    onOpenChange();
    satisfactionModalRef.current.hide();
  };

  return (
    <div
      ref={satisfactionModalRef}
      className="modal fade"
      id="modalSatisfaction"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalSatisfactionLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalSatisfactionForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalSatisfactionLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href="#ico-edit"></use>
                </svg>
              </div>
              <div className="modal__title__text">滿意度調查</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-12">
                      <label
                        htmlFor="modalCSATContentSurvey"
                        className="form-label"
                      >
                        滿意度調查
                      </label>
                      <div>
                        {Array(5)
                          .fill()
                          .map((_, i) => (
                            <i
                              key={i}
                              onMouseEnter={() => handleScoreTouch(i + 1)}
                              className={
                                'bi bi-star-fill' +
                                (satisfactionFormValue.satisfactionScore > i
                                  ? ' star-checked'
                                  : '')
                              }
                            ></i>
                          ))}
                      </div>
                    </div>
                    <div className="col-12 mt-3">
                      <label
                        htmlFor="modalCSATContentSurveyComment"
                        className="form-label"
                      >
                        客戶反饋內容
                      </label>
                      <textarea
                        className="form-control mt-2"
                        id="modalCSATContentSurveyComment"
                        rows="3"
                        value={satisfactionFormValue.comment || ''}
                        onChange={(e) =>
                          setSatisfactionFormValue({
                            ...satisfactionFormValue,
                            comment: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-cancel" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
